import { fetchReducerFactory } from '../../../shared/store/fetchFactory';
import {
  UPDATE_SCENARIO_REPORT_VALUE,
  RESET_SCENARIO_REPORT_VALUE,
} from './types';
import initialState from './initialState';


const fetchReducer = fetchReducerFactory(
  {
    [UPDATE_SCENARIO_REPORT_VALUE]: 'UpdateReportValue',
    [RESET_SCENARIO_REPORT_VALUE]: 'ResetReportValue',
  },
  initialState
);


const scenarioEtrReducer = (state = initialState, action) => {
  switch (action.type) {
    default: {
      return fetchReducer(state, action);
    }
  }
};

export default scenarioEtrReducer;
